// extracted by mini-css-extract-plugin
export default {"item":"oVtF023B8jg4_buOvCwu","version-tag":"eBY_KtWhlhhpCQpFfZVW","versionTag":"eBY_KtWhlhhpCQpFfZVW","chevron":"w83wcniTVQlIXDz_6bHJ","date":"axQtUzH_KR4ablhWxArN"};